import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import style from './FieldStatus.module.scss.js';

var _excluded = ["className", "message", "variant", "show", "children"];
var FieldStatus = function FieldStatus(_ref) {
  var _cx;
  var className = _ref.className,
    message = _ref.message,
    variant = _ref.variant,
    show = _ref.show,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var classes = cx(style.container, variant && "validation-" + variant, (_cx = {}, _cx[style.visible] = show, _cx[style.loading] = variant === 'loading', _cx), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes,
    "data-validation": variant !== 'loading' ? message : null
  }, props), /*#__PURE__*/React.cloneElement(children, {
    isInlineRight: true
  }));
};
FieldStatus.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * Inline validation message
   */
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  show: PropTypes.bool,
  /**
   * Inline validation variant it can be success or danger
   */
  variant: PropTypes.oneOf(['success', 'danger', 'warning', 'loading'])
};
FieldStatus.defaultProps = {
  variant: 'success'
};

export { FieldStatus as default };
//# sourceMappingURL=index.js.map
